module.exports = __webpack_public_path__ + "static/media/9.7408b1ab.jpeg";